<template>
    <div class="table-row-cells">
        <slot></slot>

        <div class="table-td cell-activity">
            <span v-if="patient.data && patient.data.days_since_page_viewed === 0" class="indicator-item">{{ __('Today') }}</span>
            <span v-else-if="patient.data && patient.data.days_since_page_viewed > 0" class="indicator-item">{{ __choice('{1} :days d|[2,*] :days d', patient.data.days_since_page_viewed, {'days': patient.data.days_since_page_viewed}) }}</span>
            <span v-else class="indicator-item">-</span>
        </div>

        <div class="table-td">
            <figure class="icon-badge">
                <svg-icon icon="icon-graduate-badge" />
            </figure>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        patient: {
            type: Object,
            required: true
        }
    }
}
</script>
